/* eslint-disable no-param-reassign, no-nested-ternary */
export const getState = state => state.filters;

/* ========================== CATEGORIES ========================= */
export const getCategorySelected = state => {
  // const t0 = performance.now();
  const { categories, categorySelected: categoryInfo } = getState(state);

  const categorySelected = categories[categoryInfo.itemId];
  const subCategoriesSelected = categorySelected
    ? Object.keys(categorySelected.subItems).reduce((arr, key) => {
        const currentSubItem = categorySelected.subItems[key];

        if (
          currentSubItem.id === categoryInfo.subItemId &&
          currentSubItem.id !== 0
        ) {
          arr.push(currentSubItem);
        }

        return arr;
      }, [])
    : [];

  // const t1 = performance.now();

  // console.log(`${t0} to ${t1}> Call getCategorySelected took: ${t1 - t0} miliseconds`);
  return {
    categorySelected,
    subCategoriesSelected,
  };
};

/* ========================== SOFTWARES ========================= */

export const getSoftwaresSelectedIds = state => {
  const { softwaresSelected } = getState(state);

  return Object.keys(softwaresSelected).map(key => softwaresSelected[key].id);
};

export const getSoftwaresSelected = state => {
  const filters = getState(state);
  const keys = Object.keys(filters.softwaresSelected);

  return keys.map(key => filters.softwaresSelected[key]);
};

/* ========================== LEVELS ========================= */

export const getLevelsSelectedIds = state => {
  const { levelsSelected } = getState(state);

  return Object.keys(levelsSelected).map(key => levelsSelected[key].id);
};

export const getLevelsSelected = state => {
  const filters = getState(state);
  const keys = Object.keys(filters.levelsSelected);

  return keys.map(key => filters.levelsSelected[key]);
};

export const isFilterApplied = state => {
  // const t0 = performance.now();
  const isApplied =
    !!getCategorySelected(state).categorySelected ||
    !!(getSoftwaresSelected(state).length > 0) ||
    !!getLevelsSelected(state).length > 0;
  // const t1 = performance.now();

  // console.log(`${t0} to ${t1}> Call isFilterApplied took: ${t1 - t0} miliseconds`);

  return isApplied;
};

/** *************** Language **************** */
export const getSelectedLanguageIds = state => {
  const { selectedLanguages } = getState(state);

  return Object.keys(selectedLanguages).map(key => selectedLanguages[key].id);
};

export const getSelectedLanguages = state => {
  const filters = getState(state);
  const keys = Object.keys(filters.selectedLanguages);

  return keys.map(key => filters.selectedLanguages[key]);
};

// SEO HELPERS
export const getUrl = state => {
  const firstPosition = 'cursos';
  const secondPosition = state.orderBy.itemSelected.value;
  const { countryPrefix } = state;

  const { categorySelected, subCategoriesSelected } = getCategorySelected(
    state,
  );
  const softwaresSelected = getSoftwaresSelected(state);
  const levelsSelected = getLevelsSelected(state);
  const selectedLanguages = getSelectedLanguages(state);

  const allCoursesParam = state.filters.allCourses;
  const search = state.search.value;
  let thirdPositionCategory = '';
  let thirdPositionSoftware = '';
  const queryParams = [];

  if (subCategoriesSelected.length > 0) {
    if (subCategoriesSelected.length > 1) {
      queryParams.push(
        `subCategories=${subCategoriesSelected.map(sc => sc.slug).join(',')}`,
      );
    } else {
      thirdPositionCategory = subCategoriesSelected[0].slug;
    }
  } else if (categorySelected) {
    thirdPositionCategory = categorySelected.slug;
  }

  if (softwaresSelected.length > 0) {
    if (softwaresSelected.length > 1 || thirdPositionCategory) {
      queryParams.push(
        `software=${softwaresSelected.map(s => s.slug).join(',')}`,
      );
    } else {
      thirdPositionSoftware = softwaresSelected[0].slug;
    }
  }

  if (levelsSelected.length > 0) {
    queryParams.push(`nivel=${levelsSelected.map(l => l.slug).join(',')}`);
  }

  if (selectedLanguages.length) {
    queryParams.push(
      `idiomas=${selectedLanguages
        .map(selectedLang => selectedLang.slug)
        .join(',')}`,
    );
  }

  if (search) {
    queryParams.push(`q=${search}`);
  }

  if (allCoursesParam) {
    queryParams.push('all=true');
  }

  const baseUrl = `${firstPosition}-${secondPosition}`;
  const thirdPosition = thirdPositionCategory || thirdPositionSoftware;
  const restUrl = thirdPosition ? `-${thirdPosition}` : '';
  const queryUrl = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const prefix =
    countryPrefix && countryPrefix.toLowerCase
      ? `/${countryPrefix.toLowerCase()}`
      : '';

  return `${prefix}/${baseUrl}${restUrl}/${search ? 'search/' : ''}${queryUrl}`;
};
